import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../../utils/apiFetch'
import apiPath from '../../../utils/apiPath'
import Pagination from '../../Pagination'
import AuthContext from 'context/AuthContext'
import dayjs from 'dayjs'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import helpers from '../../../utils/helpers'
import OnboardingList from './OnboardingList'

function Onboarding ({ manager }) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { logoutUser, user, updatePageName } = useContext(AuthContext)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [formsManager, setFormsManager] = useState([])
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [isDelete, setIsDelete] = useState(false)
  const [items, setItem] = useState('')
  const [filterData, setFilterData] = useState({
    category: '',
    searchKey: '',
    startDate: '',
    endDate: '',
    isReset: false,
    isFilter: false
  })
  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')
  const [isInitialized, setIsInitialized] = useState(false)
  const [sort, setSort] = useState({
    sortBy: 'createdAt',
    sortType: 'desc'
  })

  // const handleUserView = item => {
  //   setItem(items)
  //   navigate('/forms-manager/view', { state: item })
  // }
  
  const handleUserView = (formId) => {
    setItem(items)
    navigate('/forms-manager/view', { state: { id: formId } })
  }
  const getFormsManager = async data => {
    try {
      const { category, startDate, endDate, searchKey, isFilter } = filterData
      if (
        (data?.deletePage && formsManager?.length >= 1) ||
        (isFilter &&
          category &&
          data?.statusChange &&
          formsManager?.length >= 1)
      ) {
        if (formsManager?.length >= 1) {
          setPage(page - 1)
          setIsDelete(true)
          setPaginationObj({ ...paginationObj, page: page - 1 })
        }
      } else {
        setIsDelete(false)
      }
      const payload = {
        page,
        pageSize,
        status: category,
        startDate: helpers?.ternaryCondition(
          startDate,
          dayjs(startDate).format('YYYY-MM-DD'),
          null
        ),
        endDate: helpers?.ternaryCondition(
          endDate,
          dayjs(endDate).format('YYYY-MM-DD'),
          null
        ),
        keyword: searchKey,
        sortBy: sort.sortBy,
        sortType: sort.sortType,
        categoryType: 'onboarding'
      }
      const path = apiPath.getFormsManager
      const result = await apiGet(path, payload)
      if (result?.status === 200) {
        const response = result?.data?.results
        const resultStatus = result?.data?.success
        setFormsManager(response?.docs)
        setPaginationObj({
          ...paginationObj,
          page: helpers?.ternaryCondition(resultStatus, response.page, null),
          pageCount: helpers?.ternaryCondition(
            resultStatus,
            response.totalPages,
            null
          ),
          perPageItem: helpers?.ternaryCondition(
            resultStatus,
            response?.docs.length,
            null
          ),
          totalItems: helpers?.ternaryCondition(
            resultStatus,
            response.totalDocs,
            null
          )
        })
      }
    } catch (error) {
      console.log('error ', error)
      setPaginationObj({})
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser()
      }
    }
  }

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  useEffect(() => {
    getFormsManager()
  }, [page, filterData, sort])

  const handleReset = () => {
    setFilterData({
      category: '',
      searchKey: '',
      startDate: '',
      endDate: '',
      isReset: true,
      isFilter: false
    })
    setPage(1)
    setIsDelete(true)
    setSearchTerm('')
  }

  const handleDateChange = (start, end) => {
    setPage(1)
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true
    })
    setIsDelete(true)
  }

  useEffect(() => {
    if (!isInitialized) {
      setIsInitialized(true)
    } else if (searchTerm || !filterData?.isReset) {
      setFilterData({
        ...filterData,
        isReset: false,
        searchKey: helpers?.ternaryCondition(
          debouncedSearchTerm,
          debouncedSearchTerm,
          ''
        ),
        isFilter: helpers?.ternaryCondition(debouncedSearchTerm, true, false)
      })
      setPage(1)
    }
  }, [debouncedSearchTerm])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm)
    }, 500)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [searchTerm])

  useEffect(() => {
    updatePageName(t('FORMS_MANAGER'))
  }, [])

  return (
    <div>
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            <form className='border-b border-b-[#E3E3E3] grid 2xl:grid-cols-3 xl:grid-cols-2 lg:grid lg:grid-cols-1 gap-2 px-4 py-3'>
              <div className='col-span-2 flex flex-wrap  items-center'>
                <div className='flex items-center lg:pt-0 pt-3 flex-wrap mb-2'>
                  <div className='relative flex items-center mb-3'>
                    <div className='absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none'>
                      {!searchTerm ? (
                        <svg
                          aria-hidden='true'
                          className='w-4 h-4 text-[#A5A5A5] dark:text-gray-40'
                          fill='none'
                          stroke='currentColor'
                          viewBox='0 0 24 24'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth='2'
                            d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                          />
                        </svg>
                      ) : (
                        ''
                      )}
                    </div>
                    <input
                      type='search'
                      id='default-search'
                      className='block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[250px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                      placeholder={t('SEARCH_BY_TITLE')}
                      value={searchTerm}
                      title=''
                      required
                      onChange={e => setSearchTerm(e.target.value)}
                    />
                  </div>
                  <ODateRangePicker
                    handleDateChange={handleDateChange}
                    isReset={filterData?.isReset}
                    setIsReset={setFilterData}
                  />
                  <button
                    type='button'
                    onClick={handleReset}
                    className='bg-LightBlue text-sm px-8 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2'
                  >
                    {t('O_RESET')}
                  </button>
                </div>
              </div>
            </form>
            <OnboardingList
              formsManager={formsManager}
              user={user}
              getFormsManager={getFormsManager}
              handleUserView={handleUserView}
              page={page}
              setSort={setSort}
              sort={sort}
              manager={manager}
            />
            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                isDelete={isDelete}
                page={page}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}
export default Onboarding
